import { IBasePathParams } from 'common/models/requestModels';

// MBC-84 Phase 2: `profile` widened locally to string — the generated union still only knows the
// v1 profile ids (marketing/sales_operations). Remove the Omit-override after `yarn models:build`.
export interface IUserModel extends Omit<Components.Schemas.UserDto, 'profile'> {
  name?: string;
  mappedRole?: string;
  isPayMongoAPIKeysSet?: boolean;
  profile?: string | null;
}
export interface IUserCollection extends Components.Schemas.UserCollection {}
export interface IUserUpdateData extends Omit<Components.Schemas.UpdateUserDto, 'profile'> {
  profile?: string;
}
export interface IUserInviteData extends Omit<Components.Schemas.CreateUserDto, 'profile'> {
  profile?: string;
}
export interface IUserUpdatePasswordData extends Components.Schemas.UpdatePasswordDto {}
export interface IUserConfirmData extends Components.Schemas.JoinUserDto {}
// Franchisee self-registration via Leslie guid link — local until `yarn models:build` (MBC-51-fix pattern).
export interface IFranchiseeRegistrationInfo {
  storeName: string | null;
  maskedEmail: string;
}
export interface IFranchiseeRegisterData {
  guid: string;
  password: string;
  firstName: string;
  lastName: string;
  phone: string;
}
export interface IFranchiseeData extends Components.Schemas.ShortFranchiseeDto {}
export interface IUserCollectionFilter extends Paths.UserControllerList.QueryParameters {
  pageIndex?: number;
}

export interface IPayMongoAPIKeys extends Components.Schemas.PayMongoApiKeysDto {}
export interface IPayMongoState extends Components.Schemas.PayMongoConfigStatusDto {}
export interface IOtpModel extends Components.Schemas.OtpDto {}

export interface IUserModelParams {
  path?: IBasePathParams;
  data?: IUserInviteData | IUserUpdateData | IUserUpdatePasswordData | IPayMongoAPIKeys;
}

export enum EUserRole {
  // ponytail: value must match the api role enum the parallel agent adds (`'superadmin'`).
  SuperAdmin = 'superadmin',
  Franchisor = 'franchisor',
  Franchisee = 'franchisee',
  Manager = 'manager',
  SalesOps = 'salesop',
  Customer = 'customer',
}
export enum EUserRoleText {
  SuperAdmin = 'Super Admin',
  Franchisor = 'Franchisor',
  Franchisee = 'Franchisee',
  Manager = 'Manager',
  SalesOps = 'Sales Ops',
  Customer = 'Customer',
}

export const roleDict = {
  [EUserRole.SuperAdmin]: EUserRoleText.SuperAdmin,
  [EUserRole.Franchisor]: EUserRoleText.Franchisor,
  [EUserRole.Franchisee]: EUserRoleText.Franchisee,
  [EUserRole.SalesOps]: EUserRoleText.SalesOps,
  [EUserRole.Manager]: EUserRoleText.Manager,
  [EUserRole.Customer]: EUserRoleText.Customer,
};

export enum EUserStatus {
  Active = 'active',
  Blocked = 'blocked',
  Pending = 'pending',
}
export enum EUserStatusText {
  Active = 'Active',
  Blocked = 'Blocked',
  Pending = 'Pending',
}

export const tableUserConfig = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    ellipsis: true,
  },
  {
    title: 'Phone Number',
    dataIndex: 'phone',
    key: 'phone',
    ellipsis: true,
  },
  {
    title: 'Role',
    dataIndex: 'mappedRole',
    key: 'mappedRole',
    ellipsis: true,
  },
  {
    title: 'Position',
    dataIndex: 'profileName',
    key: 'profileName',
    ellipsis: true,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
  },
];

export enum EUserSuccessMessage {
  SetAPIKeys = 'API Keys have been successfully set up. Now you can accept payments.',
  ResetAPIKeys = 'API Keys have been successfully reset.',
  ChangePassword = 'Password successfully changed',
  ReInviteSend = 'Invitation has been sent to the specified email',
  Delete = 'Invitation has been successfully cancelled',
  Invite = 'Employee has been successfully invited',
  Edit = 'Employee has been successfully edited',
}

export enum EUserProfile {
  Marketing = 'marketing',
  SalesOperations = 'sales_operations',
}
